import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./VoucherPage.module.css";
import { getAccessToken } from "../../../utils/authStorage";

// Use environment variable for the base URL
const ENV_API_URL =
    import.meta.env.VITE_API_URL || "https://pixelmoonstore.in/api/v1";
const BASE_API_URL = ENV_API_URL.replace(/\/v1\/?$/, "");

export default function VoucherPage() {
    const [vouchers, setVouchers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchVouchers();
    }, []);

    const fetchVouchers = async () => {
        try {
            const token = getAccessToken();
            const headers = { "Content-Type": "application/json" };
            if (token) headers["Authorization"] = `Bearer ${token}`;

            const res = await fetch(`${BASE_API_URL}/v1/vouchers/available`, {
                headers,
            });

            if (!res.ok) throw new Error("Failed to fetch vouchers");

            const data = await res.json();
            setVouchers(data.vouchers || []);
        } catch (err) {
            console.error(err);
            setError("Failed to load available vouchers.");
        } finally {
            setLoading(false);
        }
    };

    const handleBuy = (voucher) => {
        // Navigate to checkout with voucher details
        navigate("/checkout/voucher", { state: { voucher } });
    };

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.spinner}></div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h1 className={styles.title}>Digital Vouchers</h1>
                <p className={styles.subtitle}>
                    Instant delivery of your favorite game cards and gift vouchers.
                </p>
            </header>

            {error && <div className={styles.error}>{error}</div>}

            {!loading && vouchers.length === 0 ? (
                <div className={styles.emptyState}>
                    <p>No vouchers available at the moment. Check back soon!</p>
                </div>
            ) : (
                <div className={styles.grid}>
                    {vouchers.map((voucher, index) => (
                        <div key={index} className={styles.card}>
                            <div className={styles.imageContainer}>
                                {voucher.image ? (
                                    <img src={voucher.image} alt={voucher.name} />
                                ) : (
                                    <div className={styles.placeholderImage}>
                                        {voucher.name.charAt(0)}
                                    </div>
                                )}
                                <div className={styles.priceTag}>₹{voucher.retailPrice}</div>
                            </div>
                            <div className={styles.cardContent}>
                                <h3 className={styles.cardTitle}>{voucher.name}</h3>
                                <div className={styles.cardDetails}>
                                    <span className={styles.badge}>{voucher.type}</span>
                                    <span className={styles.stock}>
                                        {voucher.availableCount > 0 ? "In Stock" : "Out of Stock"}
                                    </span>
                                </div>
                                {/* <p className={styles.denomination}>
                  Value: {voucher.denomination}
                </p> */}

                                <button
                                    className={styles.buyButton}
                                    onClick={() => handleBuy(voucher)}
                                    disabled={voucher.availableCount === 0}
                                >
                                    {voucher.availableCount > 0 ? "Buy Now" : "Sold Out"}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
